import { startDateForSubmit } from "@/pages/performances/lib/performance-start-date";

/**
 * Decides the `startDate` a screening save sends, given the picker's wall clock.
 *
 * The picker shows the venue's local time. Two things can make the stored instant move:
 * - the curator changed the time, or
 * - the curator picked a venue in ANOTHER zone — then the shown wall clock is kept and read in
 *   the new zone (20:00 stays 20:00 at the new cinema), so the instant changes.
 *
 * A picked venue whose zone is unknown falls back to the old zone, not to the browser's.
 *
 * @returns the ISO instant to send, or `undefined` when `startDate` must not be sent at all.
 */
export function screeningStartForSubmit({
  pickerValue,
  startChanged,
  originalZone,
  pickedZone,
}: {
  pickerValue: string | null | undefined;
  startChanged: boolean;
  originalZone: string | undefined;
  /** The newly picked venue's zone; `undefined` when the venue did not change or has none. */
  pickedZone: string | undefined;
}): string | undefined {
  const zoneMoved = pickedZone !== undefined && pickedZone !== originalZone;
  if (!startChanged && !zoneMoved) return undefined;
  return startDateForSubmit(pickerValue, pickedZone ?? originalZone);
}
